<template>
	<div class="tx">
		<header>
			<h1>
				<router-link to="/mine/card">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">添加银行卡</p>
			</h1>
		</header>
		<div class="txa">
			<div class="cardx">
				<p class="name">银行卡名</p>
				<input type="text" placeholder="请输入银行卡名" class="cardname _cardname">
			</div>
			<div class="cardx">
				<p class="number">银行卡号</p>
				<input type="number" placeholder="请输入银行卡号" class="cardnm _cardnumber">
			</div>
			<div class="cardx">
				<p class="number">开户支行</p>
				<input type="text" placeholder="请输入开户支行" class="cardnm _opening">
			</div>
			<div class="cardx">
				<p class="number">手机号码</p>
				<input type="number" placeholder="请输入手机号码" class="cardnm _cardphone">
			</div>
			<div class="cardx">
				<p class="number">个人姓名</p>
				<input type="text" placeholder="请输入个人姓名" class="cardnm _username">
			</div>
		</div>
		<button class="tixiancard" v-on:click="add()">添加银行卡</button>
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
data() {
	return {
	}
},
mounted(){

},
methods:{
	add:function(){
		var _cardname= $('._cardname').val();
		var _cardnumber= $('._cardnumber').val();
		var _opening=$('._opening').val();
		var _cardphone= $('._cardphone').val();
		var _username= $('._username').val();
		var openid=localStorage.getItem("openid");
		if(_cardname == '' || _cardname == null){
			$('.tc_navx').text('请填写银行卡名')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(_cardnumber == '' || _cardnumber == null){
			$('.tc_navx').text('请填写银行卡号')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(_opening == '' || _opening == null){
			$('.tc_navx').text('请输入开户支行')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(_cardphone == '' || _cardphone == null){
			$('.tc_navx').text('请填写手机号码')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(_username == '' || _username == null){
			$('.tc_navx').text('请填写个人姓名')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else{
        $.get(CURL+"/portal/All/getaddbank",{"_cardname":_cardname,"_cardnumber":_cardnumber,"_cardphone":_cardphone,"_username":_username,"openid":openid,'bank_branch':_opening},function(data){
            //console.log(data.new);//获取ajax请求参数
            if(data.new==1){
                $('.tc_navx').text('添加成功')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
//					location.href = '/mine/card';
					this.$router.push({path:'/mine/card'})
				},2000)
            }else if(data.new==2){
                $('.tc_navx').text('该银行卡已存在')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
            }
        });
		}
    },

}
}
</script>
<style lang="scss" scoped>
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
/*	height: 30px;*/
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
/**/
.tixiancard{
	float: left;
	width: 80%;
	margin: 60px 10% 0 10%;
	padding: 12px 0 12px 0;
	border-radius: 5px;
	background:url(../../img/ss.png);
  	background-size: cover 100% 100%;
  	background-repeat: no-repeat;
	color: #FFFFFF;
	font-weight: 550;
}
.cardnm,.cardname{
	float: left;
	width: 80%;
}
.name,.number{
	float: left;
	width: 20%;
}
.cardx{
	margin-top: 10px;
	float: left;
	width: 100%;
	border-bottom: #eee solid 1px;
	padding: 10px 5px 20px 5px;
}
.txa{
	margin-top: 38px;
	float: left;
	width: 100%;
	background-color: #FFFFFF;
}
/*head*/
header{
	position: fixed;
  	height: .4rem;
 	background:url(../../img/ss.png);
  	background-size:100% 100%;
  	background-repeat: no-repeat;
 	float: left;
 	width: 100%;
}
.set_1{
	text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top: 12px;
	width: 5%;
	color: #FFFFFF;
}
.tx{
	width: 100%;
	background-color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/addcard.vue